import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../ReduxToolkit/Hooks";
import { fetchUserAndRoles } from "../ReduxToolkit/Reducers/Layout/AuthReducer";

interface AuthInitializerProps {
  children: React.ReactNode;
}

const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { token, user, isAuthenticated, userLoading } = useAppSelector(
    (state) => state.auth
  );
  const rolesLoaded = user && user.roles && user.roles.length >= 0;

  useEffect(() => {
    if (token && (!user || !user.roles) && !userLoading) {
      dispatch(fetchUserAndRoles());
    }
  }, [token, user, userLoading, dispatch]);
  const isDataLoaded = user && !userLoading && rolesLoaded;

  if (isAuthenticated && !isDataLoaded) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading user session...
      </div>
    );
  }
  return <>{children}</>;
};

export default AuthInitializer;
